import { render, staticRenderFns } from "./sheet-view-tab.vue?vue&type=template&id=05dbf1aa&scoped=true&"
import script from "./sheet-view-tab.vue?vue&type=script&lang=js&"
export * from "./sheet-view-tab.vue?vue&type=script&lang=js&"
import style0 from "./sheet-view-tab.vue?vue&type=style&index=0&id=05dbf1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dbf1aa",
  null
  
)

export default component.exports